import { Link } from "react-router-dom";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#0F2557] font-bold text-lg">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-base"></i>
            </div>
            Wróć na stronę główną
          </Link>
          <span className="text-xs text-gray-400">Ostatnia aktualizacja: 03.04.2026</span>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
        <header className="mb-12">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">Dokument prawny</span>
          <h1 className="text-4xl font-bold text-[#1A1A2E] mb-4">Polityka Prywatności</h1>
          <p className="text-gray-500 text-lg">Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych przekazywanych przez Użytkowników w związku z korzystaniem z serwisu internetowego.</p>
        </header>

        <div className="prose max-w-none text-gray-600 leading-relaxed space-y-10">

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">1. Administrator danych osobowych</h2>
            <p>Administratorem danych osobowych jest Tomasz Kowalski, prowadzący działalność w zakresie tworzenia stron internetowych dla firm usługowych, dostępny pod adresem e-mail: <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] font-medium hover:underline">tomasz.kdp@gmail.com</a> oraz pod numerem telefonu: <a href="tel:+48509963499" className="text-[#0F2557] font-medium hover:underline">+48 509 963 499</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">2. Jakie dane zbieramy</h2>
            <p className="mb-3">W ramach korzystania z serwisu możemy zbierać następujące dane osobowe:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Imię i nazwisko lub nazwa firmy</li>
              <li>Adres e-mail</li>
              <li>Numer telefonu</li>
              <li>Informacje o branży i lokalizacji działalności</li>
              <li>Treść wiadomości przesłanych przez formularz kontaktowy</li>
              <li>Dane techniczne: adres IP, typ przeglądarki, czas wizyty (pliki cookies)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">3. Cel i podstawa prawna przetwarzania</h2>
            <p className="mb-3">Dane osobowe przetwarzane są w następujących celach:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#1A1A2E]">Odpowiedź na zapytanie</strong> — na podstawie art. 6 ust. 1 lit. b RODO (niezbędność do podjęcia działań przed zawarciem umowy)</li>
              <li><strong className="text-[#1A1A2E]">Zawarcie i realizacja umowy</strong> — na podstawie art. 6 ust. 1 lit. b RODO</li>
              <li><strong className="text-[#1A1A2E]">Marketing bezpośredni</strong> — na podstawie art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes administratora), wyłącznie za zgodą</li>
              <li><strong className="text-[#1A1A2E]">Analityka i statystyki</strong> — na podstawie art. 6 ust. 1 lit. f RODO</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">4. Okres przechowywania danych</h2>
            <p>Dane osobowe przechowywane są przez okres niezbędny do realizacji celów, dla których zostały zebrane:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Dane z formularza kontaktowego — do 12 miesięcy od ostatniego kontaktu</li>
              <li>Dane związane z umową — przez okres 5 lat od zakończenia umowy (wymogi podatkowe)</li>
              <li>Dane marketingowe — do czasu cofnięcia zgody</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">5. Prawa użytkownika</h2>
            <p className="mb-3">Przysługują Ci następujące prawa w zakresie ochrony danych osobowych:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#1A1A2E]">Prawo dostępu</strong> — możesz uzyskać informację o przetwarzanych danych</li>
              <li><strong className="text-[#1A1A2E]">Prawo do sprostowania</strong> — możesz żądać poprawienia nieprawidłowych danych</li>
              <li><strong className="text-[#1A1A2E]">Prawo do usunięcia</strong> — możesz żądać usunięcia danych (&quot;prawo do bycia zapomnianym&quot;)</li>
              <li><strong className="text-[#1A1A2E]">Prawo do ograniczenia przetwarzania</strong></li>
              <li><strong className="text-[#1A1A2E]">Prawo do przenoszenia danych</strong></li>
              <li><strong className="text-[#1A1A2E]">Prawo do sprzeciwu</strong> wobec przetwarzania</li>
              <li><strong className="text-[#1A1A2E]">Prawo do skargi</strong> do Prezesa Urzędu Ochrony Danych Osobowych (UODO)</li>
            </ul>
            <p className="mt-3">Aby skorzystać z powyższych praw, skontaktuj się pod adresem: <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] font-medium hover:underline">tomasz.kdp@gmail.com</a></p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">6. Udostępnianie danych</h2>
            <p>Dane osobowe nie są sprzedawane ani udostępniane podmiotom trzecim w celach marketingowych. Mogą być przekazywane wyłącznie:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Podmiotom świadczącym usługi hostingowe i techniczne (jako podmioty przetwarzające)</li>
              <li>Organom publicznym, jeśli wymagają tego przepisy prawa</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">7. Bezpieczeństwo danych</h2>
            <p>Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony danych osobowych przed nieuprawnionym dostępem, utratą lub zniszczeniem, w tym szyfrowanie połączeń (SSL/TLS).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">8. Kontakt</h2>
            <p>W sprawach dotyczących ochrony danych osobowych prosimy o kontakt:</p>
            <div className="mt-3 bg-[#F7F8FA] rounded-lg p-5 space-y-2">
              <p className="text-sm"><strong className="text-[#1A1A2E]">E-mail:</strong> <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] hover:underline">tomasz.kdp@gmail.com</a></p>
              <p className="text-sm"><strong className="text-[#1A1A2E]">Telefon:</strong> <a href="tel:+48509963499" className="text-[#0F2557] hover:underline">+48 509 963 499</a></p>
            </div>
          </section>

        </div>
      </main>

      <footer className="border-t border-gray-100 py-8 mt-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} Strony www dla firm usługowych. Wszelkie prawa zastrzeżone.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/polityka-prywatnosci" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Polityka prywatności</Link>
            <Link to="/rodo" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">RODO</Link>
            <Link to="/regulamin" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Regulamin</Link>
            <Link to="/polityka-cookies" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Cookies</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
